// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseInputs_container__1KHI2","slideIn":"BaseInputs_slideIn__1gqKM","value__container":"BaseInputs_value__container__22QjS","amount":"BaseInputs_amount__2K3S5"};